import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { Accordion, AccordionContent, AccordionTitle, Button, Grid, GridColumn, GridRow, Header, Icon, List, ListContent, ListHeader, ListItem, Loader, Menu,  Segment,  Tab, TabPane } from "semantic-ui-react";
import { getClinicWeeklySchedule, setSlotState } from "../queries";
import { useAppContext } from "../AppContext";
import { getTimestamp } from "../TimeStamp";
import errorHandler from "../ErrorHandler";
import MultipleSetSlotForm from "./MultipleSetSlotForm";


const ClinicAppointmentsMobile = () => {
    const { t, i18n } = useTranslation();
    const { rtl } = useAppContext();

    const [gotData, setGotData] = useState(false)

    const {
        data,
        error, // TODO: error
        isLoading,
        refetch: refetchTable,
    } = useQuery("getClinicWeeklyScheduleMobile", getClinicWeeklySchedule, {
        onSettled: (response) => {
            if (!gotData){
                setGotData(true);
                setActiveIndex(getDefaultActiveIndex(response))
            }
        }
    });
    
    const setTimeslotMutation = useMutation(setSlotState, {
        onSettled: (response) => {refetchTable(); errorHandler(response, t)},
    });

    const handleEnableTimeslot = (start_time, day) => {
        setTimeslotMutation.mutate({ time: getTimestamp(start_time, day), state: true})
    }

    const handleDisableTimeslot = (start_time, day) => {
        setTimeslotMutation.mutate({ time: getTimestamp(start_time, day), state:false });
    }


    const getDefaultActiveIndex = (data) => {
        let d = new Date().getDay();
        if (d >= 5) return 0;
        if (data){
            if (Object.keys(data).length < 5-d) return d+1;
        }
        return d;
    };

    const [activeIndex, setActiveIndex] = useState(getDefaultActiveIndex(data));
    
    const [activeRow, setActiveRow] = useState(null);
    console.log(data)

    return !isLoading && data ? (
        <>
        <Header size="large" textAlign="center">{t("view-schedule")}</Header>
        <Tab
            className="clinic-appointments-mobile"
            menu={{ secondary: true }}
            activeIndex={activeIndex}
            panes={['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'].map((day, index) => ({
                menuItem: <Menu.Item active={index === activeIndex} disabled={index < getDefaultActiveIndex(data)} onClick={() => setActiveIndex(index)}>{t(day)}</Menu.Item>,              
                render: () => data[day] && (
                    <>
                        <TabPane key={day} attached={false} loading={isLoading}>
                            <Grid columns={1} stackable={false}>
                                { data[day].map(({ course_name, phone_number, email, name, is_disabled, start_time, notes }) => (
                                <GridRow key={start_time}>                                    
                                    <Accordion styled>
                                        <AccordionTitle
                                            active={activeRow === start_time}
                                            index={0}
                                            onClick={() => setActiveRow(activeRow === start_time ? null : start_time)}
                                            // style={{ border: (!is_disabled && course_name) ? '1px solid #2185d0' : '' }}
                                            className={`accordion-title ${is_disabled ? 'disabled-slot' : ''} ${!is_disabled && course_name ? 'reserved-slot' : ''}`}
                                        >
                                            <Grid columns="equal" verticalAlign="middle">
                                                <GridRow columns="equal" style={{ height: 45 }} verticalAlign="middle">
                                                    <GridColumn textAlign="right" verticalAlign="middle">
                                                        <Header as='h5' style={{ width: 'max-content' }}>
                                                            { <Icon name="dropdown" className={rtl ? "rtl" : ''} /> }
                                                            <div style={{ display: 'contents', marginRight: 35 }}>{start_time}</div>
                                                        </Header>                                                       
                                                    </GridColumn>
                                                    <GridColumn textAlign="center">
                                                        <Header as='h5'>{name}</Header>
                                                    </GridColumn>
                                                    <GridColumn textAlign="center">
                                                        <Header as='h5'>{course_name}</Header>
                                                    </GridColumn>
                                                </GridRow>
                                            </Grid>
                                        </AccordionTitle>
                                        <AccordionContent
                                            active={activeRow === start_time}
                                            // style={{ border: course_name ? '1px solid #2185d0' : '' }}
                                            className={`accordion-content ${is_disabled ? 'disabled-slot' : ''} ${!is_disabled && course_name ? 'reserved-slot' : ''}`}
                                        >
                                                <List divided>
                                                    { 
                                                        is_disabled ? (
                                                            <Segment basic size="medium" style={{ marginBottom: 0 }}>
                                                                <Header as="h5" textAlign="center">
                                                                    <Icon name="ban" size="large" />
                                                                    {t('disabled-time-slot')}
                                                                </Header>
                                                            </Segment>
                                                        ) : !course_name ? (
                                                            <Segment  basic size="medium" style={{ marginBottom: 0 }}>
                                                                <Header as="h5" textAlign="center">
                                                                    <Icon name="calendar outline" size="large" />
                                                                    {t('no-reservation')}
                                                                </Header>
                                                            </Segment>
                                                    ) : (
                                                        <>
                                                            <ListItem>
                                                                <ListContent>
                                                                <ListHeader>{t('name')}</ListHeader>
                                                                    {name}
                                                                </ListContent>
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListContent>
                                                                <ListHeader>{t('course')}</ListHeader>
                                                                    {course_name}
                                                                </ListContent>
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListContent>
                                                                <ListHeader>{t('phone')}</ListHeader>
                                                                    {phone_number && (
                                                                        <a href={`tel:${phone_number}`} target="_blank" rel="noreferrer">{phone_number}</a>
                                                                    )}
                                                                </ListContent>
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListContent>
                                                                <ListHeader>{t('email')}</ListHeader>
                                                                    {email}
                                                                </ListContent>
                                                            </ListItem>
                                                            <ListItem>
                                                                <ListContent>
                                                                <ListHeader>{t('notes')}</ListHeader>
                                                                    {notes}
                                                                </ListContent>
                                                            </ListItem>
                                                        </>
                                                    )}
                                                <ListItem>
                                                    <ListContent>
                                                    <ListHeader>{t('actions')}</ListHeader>
                                                        <div className="clinic-schedule-actions-mobile">
                                                            {
                                                                is_disabled ? (
                                                                    <Button color="blue" size="small" onClick={() => { handleEnableTimeslot(start_time, day); setActiveRow(null) } }>{t('enable-timeslot')}</Button>
                                                                ) : (
                                                                    <Button color="red" size="small" onClick={() => { handleDisableTimeslot(start_time, day); setActiveRow(null) }}>{t('disable-timeslot')}</Button>   
                                                                )
                                                            }
                                                        </div>
                                                    </ListContent>
                                                </ListItem>
                                                </List>
                                        </AccordionContent>
                                    </Accordion>
                                </GridRow>
                                ))}
                            </Grid>
                        </TabPane>
                        <br />
                        <MultipleSetSlotForm day={day} refetchTable={refetchTable} />
                    </>
                )
            }))}
        
        /></>
    ) : (
        <Loader />
    );
};

export default ClinicAppointmentsMobile;